import { Environment } from '@sondermind/utilities/models-environment';

export const environment: Environment = {
  production: true,
  staging: false,
};
